export interface IdentificationTrackingEvent {
  email: string;
  name: string;
}

export interface GroupTrackingEvent {
  groupId: string;
  groupName: string;
}

export interface PageTrackingEvent {
  name: string;
  url: string;
}

export abstract class TrackingEvent<
  Properties extends Record<string, unknown> & {
    user_id?: never;
  } = Record<string, unknown> & {
    user_id?: never;
  },
  Context extends Record<string, unknown> | null = Record<string, unknown>,
> {
  constructor(public properties = {} as Properties, public context = null as Context) {}

  abstract name: string;
}
